import React from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { Grid, GridProps } from '../../../../../../wag-react/core-components/grid';
import { Span } from '../../../../../../wag-react/core-components/span';
import { Button } from '../../../../../../wag-react/next-components/button';
export type WellnessPlanPriceSectionProps = Omit<GridProps, 'value'> & {
  value: {
    price: number;
    buttonHref: string;
  };
};
export const WellnessPlanPriceSection = ({
  value,
  ...rest
}: WellnessPlanPriceSectionProps) => <Grid alignItems="center" gridTemplateColumns="1fr" flexDirection="column" justifyItems={['initial', null, 'center']} m={['unset', null, '0 auto']} maxWidth={['100%', null, '200px']} {...rest} data-sentry-element="Grid" data-sentry-component="WellnessPlanPriceSection" data-sentry-source-file="WellnessPlanPriceSection.tsx">
    <Typography data-sentry-element="Typography" data-sentry-source-file="WellnessPlanPriceSection.tsx">
      <Typography variant="body2" color="#4669B2" fontFamily="muliBold" fontSize={['30px', null, '48px', null]} data-sentry-element="Typography" data-sentry-source-file="WellnessPlanPriceSection.tsx">
        {`$${value.price}`}
      </Typography>

      <Span display={['block', null, 'inline-block', null]} textAlign="center" data-sentry-element="Span" data-sentry-source-file="WellnessPlanPriceSection.tsx">
        /mo
      </Span>
    </Typography>

    <Button href={value.buttonHref} target="_blank" variant="contained" size="large" width={1} data-sentry-element="Button" data-sentry-source-file="WellnessPlanPriceSection.tsx">
      Select
    </Button>
  </Grid>;